module.exports = {
    values: {
        'Rig Supervisors Management': 'Gerenciamento de Fiscais',
        'Edit': 'Editar',
        'Create DIP': 'Gerar DIP',
        'Specify the DIP validity period': 'Especifique o período de vigência da DIP',
        'Start date': 'Data de início',
        'Project': 'Projeto',
        'Designer contacts': 'Contato(s) do projetista',
        'Designer': 'Projetista',
        'intervention_Coordinator': 'IPP',
        'intervention_Coordinator contacts': 'Contato(s) do IPP',
        'responsible': 'Coordenador de GEP',
        'responsibleContact': 'Contato(s) do coordenador de GEP',
        'riskAssessment': 'FAMs',
        'lastDaySummary': 'Resumo de operações',
        'Phases': 'Fases',
        'Equipment': 'Equipamento',
        'Additional Info': 'Informações adicionais',
        'Reservoir info': 'Informações do reservatório ',
        'End date': 'Data de fim',
        'Test calculation': 'Testar cálculo',
        'Processing': 'Processando',
        'Processed': 'Concluído',
        'DIP': 'DIP',
        'Close window': 'Fechar janela',
        'Copy content to clipboard': 'Copiar conteúdo',
        'USE IN CALCULATION': 'USAR NO CÁLCULO',
        'RIG': 'SONDA',
        'EXP / ARAP / AUP': 'EXP / ARAP / AUP',
        'PENTAGON': 'PENTÁGONO',
        'TYPE': 'TIPO',
        'PRIORITY': 'PRIORIDADE',
        'SUPERVISORS': 'FISCAIS',
        'Select': 'Selecionar',
        'EXP': 'EXP',
        'ARAP': 'ARAP',
        'AUP': 'AUP',
        'floating': 'Flutuante',
        'fixed': 'Fixa',
        'dualActive': 'Dual Active',
        'tripSaver': 'Trip Saver',
        'sequential': 'Sequencial',
        'Insert total number of rig supervisors, considering floating and fixed rigs': 'Insira o número total de fiscais, considerando sondas fixas e flutuantes',
        'Insert percentage of FLOATING rigs with more than 3 supervisors': 'Insira a porcentagem de sondas FLUTUANTES com mais de 3 fiscais',
        'Edit rig supervisor calculations': 'Editar cálculos de fiscais',
        'Calculate by number of rig supervisors': 'Calcular pelo número de fiscais',
        'Calculate by percentage of floating rigs with more than 3 supervisors': 'Calcular pela porcentagem de sondas flutuantes com mais de 3 fiscais',
        'ARAP rig supervisors': 'Fiscais ARAP',
        'AUP rig supervisors': 'Fiscais AUP',
        'Exploratory rig supervisors': 'Fiscais Exploratório',
        'of floating rigs with 3 supervisors': 'das sondas flutuantes com 3 fiscais',
        '% ARAP': '% ARAP',
        '% AUP': '% AUP',
        '% EXP': '% EXP',
        'Number of supervisors by area': 'Número de fiscais por área',
        'ARAP rigs': 'Sondas ARAP',
        'AUP rigs': 'Sondas AUP',
        'Exploratory rigs': 'Sondas Exploratório',
        'Return to edit mode': 'Voltar para edição',
        'from': 'Início',
        'to': 'Fim',
        'Invalid date': 'Data inválida',
        'The end date must be after the start date': 'A data de término deve ser posterior à data de início',
        'Please correct the errors and try again': 'Corrija os erros e tente novamente',
        "You haven't configured the number of rig supervisors by area yet.": 'Não foram configurados fiscais por área.',
        'Configure': 'Configurar',
        'DIP successfully copied to the clipboard.': 'DIP copiada para a área de transferência.'
    }
}
